<template>
  <div>
    <template v-for="item in routes">
      <router-link v-if="!item.hidden&&item.noDropdown&&item.children.length>0" :to="item.path+'/'+item.children[0].path">
        <el-menu-item :index="item.path+'/'+item.children[0].path">
          <icon-svg v-if='item.icon' :icon-class="item.icon" /> {{item.children[0].name}}
          <!-- <el-badge :max="99" :value="waitOrder && waitOrder.total" class="item" v-if="item.children[0].name ==='等待配送' && waitOrder && waitOrder.total > 0">
          </el-badge> -->
        </el-menu-item>
      </router-link>

      <el-submenu :index="item.name" v-if="!item.noDropdown&&!item.hidden">
        <template slot="title">
          <el-badge value="new" style="margin-right:20px" class="item" v-if="(item.name ==='商品配送'|| item.name ==='商品购物')&& waitOrder && waitOrder.total">
          </el-badge>
          <icon-svg v-if='item.icon' :icon-class="item.icon" /> {{item.name}}
          <el-badge :value="examineRemind" is-dot :hidden="item.name !== '门店管理'" v-if="!!examineRemind"> </el-badge>
        </template>
        <template v-for="child in item.children" v-if='!child.hidden'>
          <sidebar-item class='menu-indent' v-if='child.children&&child.children.length>0' :routes='[child]'>
          </sidebar-item>
          <router-link v-else class="menu-indent" :to="item.path+'/'+child.path">
            <el-menu-item :index="item.path+'/'+child.path">
              <el-badge is-dot :hidden="child.name !== '内容审核'"  v-if="!!examineRemind"> </el-badge>
              {{child.name}}
              <el-badge :max="99" style="margin-right:10px" :value="waitOrder && waitOrder.total" class="item" v-if="child.name==='等待配送' && waitOrder && waitOrder.total > 0">
              </el-badge>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>

    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SidebarItem",
  props: {
    routes: {
      type: Array
    }
  },
  computed: {
    ...mapGetters(["waitOrder",'examineRemind'])
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.svg-icon {
  margin-right: 10px;
}
.hideSidebar .menu-indent {
  display: block;
  text-indent: 10px;
}
.el-badge {
  float: right;
  margin-right: 22px;
}
// .el-menu-item .el-badge {
//   margin-right: 30px;
// }
</style>




// WEBPACK FOOTER //
// src/views/layout/SidebarItem.vue?58ad5e44